<template>
  <div class="email_grid">
    <div class="email_grid--panel">
      <email-list
        :emails="emails"
        :current-email="currentEmail"
        @updateCurrentEmail="setCurrentEmail"
      ></email-list>
    </div>

    <div class="email_grid--main">
      <new-email
        v-if="currentEmail.id === 'new'"
        :key="currentEmail.id"
        :contact="contact"
        :record="record"
        :default-data="defaultData"
        :available-records="availableRecords"
      ></new-email>

      <current-email
        v-else
        :email="currentEmail"
        v-on:reply="reply"
        v-on:replyAll="replyAll"
        v-on:forward="forward"
      ></current-email>
    </div>
  </div>
</template>

<script>
import NewEmail from "./components/NewEmail";
import CurrentEmail from "./components/CurrentEmail";
import EmailList from "./components/EmailList";
import {CommEmailModalMixin} from "./mixins/CommEmailModal.mixin";

export default {
  name: "CommEmailModalDesktop",
  components: {EmailList, CurrentEmail, NewEmail},
  mixins: [CommEmailModalMixin],
};
</script>

<style lang="scss" scoped>
.email_grid {
  height: 100%;
  display: grid;
  grid-template-columns: 332px 1fr;
  grid-template-rows: 1fr;
  gap: 0 0;
  grid-template-areas:
      "panel main";
}

.email_grid--panel {
  grid-area: panel;
  overflow-y: auto;
}

.email_grid--main {
  grid-area: main;
  overflow: hidden;
}
</style>
